/* ============================================================
   CLAIRENCE — Theme JavaScript
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {
  initHeader();
  initMobileNav();
  initSearch();
  initHeroParallax();
  initRevealAnimations();
  initProductGallery();
  initProductTabs();
  initTestimonialsSlider();
  initCartQuantity();
  initVariantSelector();
    initFaqAccordion();
});

/* ── Header scroll effect ───────────────────────────────────── */
function initHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;
  const onScroll = () => {
    header.classList.toggle('scrolled', window.scrollY > 40);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}

/* ── Mobile navigation ──────────────────────────────────────── */
function initMobileNav() {
  const toggle = document.querySelector('.header-mobile-menu');
  const nav = document.getElementById('MobileNav');
  const closeBtn = document.getElementById('MobileNavClose');
  const overlay = document.getElementById('MobileNavOverlay');
  if (!toggle || !nav) return;

  toggle.addEventListener('click', openMenu);

  function openMenu() {
    nav.classList.add('is-open');
    nav.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  window.closeMenu = function() {
    nav.classList.remove('is-open');
    nav.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  };

  closeBtn?.addEventListener('click', window.closeMenu);
  overlay?.addEventListener('click', window.closeMenu);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') window.closeMenu();
  });
}

/* ── Search panel ──────────────────────────────────────────── */
function initSearch() {
  const toggle = document.getElementById('SearchToggle');
  const panel = document.getElementById('SearchPanel');
  const close = document.getElementById('SearchClose');
  if (!toggle || !panel) return;

  toggle.addEventListener('click', () => {
    const isHidden = panel.hasAttribute('hidden');
    if (isHidden) {
      panel.removeAttribute('hidden');
      panel.querySelector('input[type="search"]')?.focus();
    } else {
      panel.setAttribute('hidden', '');
    }
  });

  close?.addEventListener('click', () => panel.setAttribute('hidden', ''));

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') panel.setAttribute('hidden', '');
  });
}

/* ── Hero parallax ──────────────────────────────────────────── */
function initHeroParallax() {
  const hero = document.querySelector('.hero-banner__media img');
  if (!hero || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  window.addEventListener('scroll', () => {
    const scrolled = window.scrollY;
    hero.style.transform = `translateY(${scrolled * 0.3}px)`;
  }, { passive: true });
}

/* ── Reveal on scroll ───────────────────────────────────────── */
function initRevealAnimations() {
  const reveals = document.querySelectorAll('.reveal');
  if (!reveals.length) return;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        setTimeout(() => entry.target.classList.add('is-visible'), i * 80);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
  reveals.forEach(el => observer.observe(el));
}

/* ── Product Gallery ────────────────────────────────────────── */
function initProductGallery() {
    const gallery = document.querySelector('.product-gallery');
      if (!gallery) return;
        const main = gallery.querySelector('.product-gallery__main img');
          const mainWrap = gallery.querySelector('.product-gallery__main');
            const thumbs = Array.from(gallery.querySelectorAll('.product-gallery__thumb'));
              const prevBtn = gallery.querySelector('.product-gallery__arrow--prev');
                const nextBtn = gallery.querySelector('.product-gallery__arrow--next');

                  let current = thumbs.findIndex(t => t.classList.contains('is-active'));
                    if (current < 0) current = 0;

                      function activate(index) {
                          if (!thumbs.length) return;
                              const total = thumbs.length;
                                  current = (index + total) % total;
                                      thumbs.forEach(t => t.classList.remove('is-active'));
                                          const thumb = thumbs[current];
                                              thumb.classList.add('is-active');
                                                  if (main) {
                                                        main.src = thumb.dataset.src || thumb.querySelector('img')?.src;
                                                              main.srcset = thumb.dataset.srcset || '';
                                                                  }
                                                                    }

                                                                      thumbs.forEach((thumb, i) => {
                                                                          thumb.addEventListener('click', () => activate(i));
                                                                            });

                                                                              if (prevBtn) prevBtn.addEventListener('click', () => activate(current - 1));
                                                                                if (nextBtn) nextBtn.addEventListener('click', () => activate(current + 1));

                                                                                  if (mainWrap && thumbs.length > 1) {
                                                                                      let startX = 0;
                                                                                          let isTouching = false;
                                                                                              mainWrap.addEventListener('touchstart', (e) => {
                                                                                                    startX = e.touches[0].clientX;
                                                                                                          isTouching = true;
                                                                                                              }, { passive: true });
                                                                                                                  mainWrap.addEventListener('touchend', (e) => {
                                                                                                                        if (!isTouching) return;
                                                                                                                              isTouching = false;
                                                                                                                                    const endX = e.changedTouches[0].clientX;
                                                                                                                                          const diff = endX - startX;
                                                                                                                                                if (Math.abs(diff) > 40) {
                                                                                                                                                        if (diff < 0) activate(current + 1);
                                                                                                                                                                else activate(current - 1);
                                                                                                                                                                      }
                                                                                                                                                                          }, { passive: true });
                                                                                                                                                                            }
                                                                                                                                                                            }

/* ── Product Tabs ───────────────────────────────────────────── */
function initProductTabs() {
  document.querySelectorAll('.product-tabs').forEach(tabs => {
    const btns = tabs.querySelectorAll('.product-tab-btn');
    const panels = tabs.querySelectorAll('.product-tab-content');
    btns.forEach(btn => {
      btn.addEventListener('click', () => {
        const target = btn.dataset.tab;
        btns.forEach(b => b.classList.remove('is-active'));
        panels.forEach(p => p.classList.remove('is-active'));
        btn.classList.add('is-active');
        tabs.querySelector(`[data-tab-panel="${target}"]`)?.classList.add('is-active');
      });
    });
  });
}

/* ── Testimonials Slider ────────────────────────────────────── */
function initTestimonialsSlider() {
  const sliders = document.querySelectorAll('.testimonials-slider');
  sliders.forEach(slider => {
    const track = slider.querySelector('.testimonials-track');
    const dots = slider.querySelectorAll('.testimonials-nav__btn');
    if (!track || !dots.length) return;
    let current = 0;
    const total = dots.length;

    function goTo(index) {
      current = index;
      const item = track.children[0];
      const itemW = item ? item.offsetWidth + 24 : 0;
      track.style.transform = `translateX(-${current * itemW}px)`;
      dots.forEach((d, i) => d.classList.toggle('is-active', i === current));
    }

    dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));

    // Auto-advance
    let autoplay = setInterval(() => goTo((current + 1) % total), 4000);
    slider.addEventListener('mouseenter', () => clearInterval(autoplay));
    slider.addEventListener('mouseleave', () => {
      autoplay = setInterval(() => goTo((current + 1) % total), 4000);
    });

    // Touch swipe
    let startX = 0;
    track.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', e => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) goTo(diff > 0 ? Math.min(current + 1, total - 1) : Math.max(current - 1, 0));
    });

    goTo(0);
    window.addEventListener('resize', () => goTo(current));
  });
}

/* ── Cart Quantity Controls ─────────────────────────────────── */
function initCartQuantity() {
  document.querySelectorAll('.cart-item__quantity').forEach(wrap => {
    const input = wrap.querySelector('.cart-item__qty-input');
    const plus = wrap.querySelector('[data-qty-action="plus"]');
    const minus = wrap.querySelector('[data-qty-action="minus"]');
    if (!input) return;

    plus?.addEventListener('click', () => {
      input.value = parseInt(input.value) + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    minus?.addEventListener('click', () => {
      const val = parseInt(input.value) - 1;
      if (val >= 0) {
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });
}

/* ── Variant Selector ───────────────────────────────────────── */
function initVariantSelector() {
  const form = document.querySelector('.product-form--main');
  if (!form) return;

  const optionBtns = form.querySelectorAll('.product-option-btn');
  optionBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const group = this.closest('.product-options__group');
      group.querySelectorAll('.product-option-btn').forEach(b => b.classList.remove('is-selected'));
      this.classList.add('is-selected');
      updateVariant(form);
    });
  });

  function updateVariant(form) {
    const selected = {};
    form.querySelectorAll('.product-options__group').forEach(group => {
      const name = group.dataset.optionName;
      const active = group.querySelector('.product-option-btn.is-selected');
      if (name && active) selected[name] = active.dataset.value;
    });

    const variantInput = form.querySelector('[name="id"]');
    const variantsField = document.getElementById('ProductVariantsData');
    const variantData = JSON.parse(variantsField?.value || '[]');
    const match = variantData.find(v =>
      v.options.every((opt, i) => {
        const key = Object.keys(selected)[i];
        return selected[key] === opt;
      })
    );

    if (match && variantInput) {
      variantInput.value = match.id;
      const priceEl = document.querySelector('.product-info__price--current');
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      const addBtn = form.querySelector('.product-form__add');
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? 'Ajouter au panier' : 'Épuisé';
      }
    }
  }
}

function formatMoney(cents) {
  return (cents / 100).toFixed(2).replace('.', ',') + ' €';
}

/* ── Announcement bar dismiss ───────────────────────────────── */
(function() {
  const bar = document.querySelector('.announcement-bar');
  const close = document.querySelector('.announcement-bar__close');
  if (close && bar) {
    close.addEventListener('click', () => {
      bar.style.maxHeight = bar.offsetHeight + 'px';
      requestAnimationFrame(() => {
        bar.style.transition = 'max-height 0.4s ease, opacity 0.4s ease';
        bar.style.maxHeight = '0';
        bar.style.opacity = '0';
        bar.style.overflow = 'hidden';
      });
    });
  }
})();

/* — FAQ accordion — */
function initFaqAccordion() {
  document.querySelectorAll('.faq-item').forEach(item => {
      const btn = item.querySelector('.faq-item__question');
          if (!btn) return;
              btn.addEventListener('click', () => {
                    const isOpen = item.classList.contains('is-open');
                          item.closest('.faq-list').querySelectorAll('.faq-item').forEach(i => i.classList.remove('is-open'));
                                if (!isOpen) item.classList.add('is-open');
                                    });
                                      });
                                      }
                                      